import React, {useEffect, useState} from "react";
import CameraComponent from "../../components/common/camera/CameraComponent";
import {useParams} from "react-router-dom";
import {RouteParam} from "../../types/types";
import {VerifyService} from "../../service/VerifyService";
import {MaskType} from "../../components/common/camera/MaskType";
import ProcessingComponent from "../../components/common/processing/ProcessingComponent";
import {useStepCheck} from "../../hooks/stepcheck/useStepCheck";
import {FacingModeType} from "../../components/common/camera/FacingModeType";
import {DocumentType, documentTypeToLabel} from "../../domain/verification/DocumentType";
import {useSubmit} from "../../hooks/submit/useSubmit";
import {RetrieveDocumentTypeViewModel} from "../../viewmodel/verification/RetrieveDocumentTypeViewModel";

const CaptureDocumentFrontPage: React.FC = () => {

    const { verificationId } = useParams<RouteParam>();
    const [loading, setLoading] = useState(false)
    const [success, setSuccess] = useState(false)
    const { evaluateUrl } = useStepCheck(verificationId)
    const { submitImage } = useSubmit(verificationId)
    const { documentType, twoSided } =
        RetrieveDocumentTypeViewModel(verificationId)

    useEffect(() => {
        evaluateUrl()
    }, [evaluateUrl])

    const onPhotoTaken = () => {
        setLoading(true)
    }

    const onSubmit = async (image: Blob) => {
        await submitImage(image, submitAction, () => setLoading(false))
    }

    const submitAction = async (blob: Blob) => {
        if (verificationId) {
            setLoading(true)
            if (documentType) {
                await VerifyService.getInstance().sendDocumentFront(blob, verificationId, documentType)
            } else {
                await VerifyService.getInstance().sendDocumentFront(blob, verificationId, DocumentType.OTHER)
            }
            setSuccess(true)
            setTimeout(async () => {
                await evaluateUrl()
                setSuccess(false)
                setLoading(false)
            }, 1000)
        }
    }

    const documentText = (documentType: DocumentType | undefined) => {
        if (documentType && twoSided) {
            return "Fit the front of your "
        } else {
            return "Fit your "
        }
    }

    const tooltip = (
        <>
            <span style={{width: "80%"}}>{documentText(documentType)}{documentType ? documentTypeToLabel(documentType).toLowerCase() : 'document'} inside the frame and make sure it’s in focus.</span>
        </>
    )

    const identifierText = documentType && (
        documentType === DocumentType.NZ_PASSPORT
        || documentType === DocumentType.OTHER
    ) ? 'Passport' : 'Front'

    return loading ?
        <ProcessingComponent loadingAnimation="processingId" successAnimation="processComplete" success={success}/> :
        <CameraComponent
            onSubmit={(blob: Blob) => onSubmit(blob)}
            onPhotoTaken={() => onPhotoTaken()}
            maskType={MaskType.DOCUMENT}
            facingMode={FacingModeType.ENVIRONMENT}
            tooltip={tooltip}
            identifierText={identifierText}
            isDocument
            withRetake
        />

}

export default CaptureDocumentFrontPage